// FILE TU DONG SINH boi scripts/update-build-date.js — DA gitignore, KHONG commit.
// Moi may/CI tu sinh lai khi cai dat (postinstall) va truoc moi lan start/build.
const buildDate = {
  devBuildDate: '24/07/2026',
  productBuildDate: '18/06/2026',
};

export default buildDate;
